import { SensorConversions } from "../conversionFunctions/sensorConversions.js";
import { SensorElementConfig } from "./types.js";

type SimpleConfig = SensorElementConfig<Record<string, never>, typeof SensorConversions.unity>;

export const solarRadiationElementConfig: SimpleConfig = {
    // Light is a single logarithmically-encoded byte; ePlant's spec truncates the W/m2 decode formula.
    // For now we pass the raw byte straight through as if it were already W/m2 (unity conversion).
    // TODO: Confirm the raw-byte -> W/m2 decode/conversion formula with ePlant, apply it (here and in
    // decodeTreeTagSensorSamples), and replace this passthrough range with the real W/m2 range.
    legalConvertedRange: [0, null],
    conversionKey: "unity",
    parameterConfigs: {},
    buildConversionParams: () => ({}),
    decodedUnits: "watt_per_square_meter",
    convertedUnits: "watt_per_square_meter",
    unitCategory: "solarRadiation",
    testCases: [
        { parameters: {}, decodedValue: 0, convertedValue: 0 },
        { parameters: {}, decodedValue: 230, convertedValue: 230 },
    ],
} as const;
